import {createCallable} from './createCallable';
export const adminGetSecrets = createCallable('adminGetSecrets');
